/*
  Alps Goodness — PDP JavaScript
  File: assets/ag-pdp.js
  Link in theme.liquid just before </body>:
    <script src="{{ 'ag-pdp.js' | asset_url }}" defer></script>
*/

(function () {
  'use strict';

  /* ─── Quantity buttons ─────────────────────────────────────── */
  const qtyInput = document.getElementById('ag-pdp-qty');
  document.getElementById('ag-pdp-qty-minus')?.addEventListener('click', () => {
    const v = Math.max(1, parseInt(qtyInput?.value || 1) - 1);
    if (qtyInput) qtyInput.value = v;
  });
  document.getElementById('ag-pdp-qty-plus')?.addEventListener('click', () => {
    const v = Math.min(99, parseInt(qtyInput?.value || 1) + 1);
    if (qtyInput) qtyInput.value = v;
  });

  /* ─── AJAX Add to Cart ─────────────────────────────────────── */
  const form = document.getElementById('ag-product-form');
  const atcBtn = document.getElementById('ag-pdp-atc-btn');
  const atcText = atcBtn?.querySelector('.ag-pdp__atc-btn-text');


    let isSubmitting = false; // ← Add this flag at the top

    form?.addEventListener('submit', async (e) => {
      if (e.target.id !== 'ag-product-form') return;
      e.preventDefault();
      
      if (!atcBtn || atcBtn.disabled || isSubmitting) return;

      // Set submission lock
      isSubmitting = true;

      // Optimistic loading state
      atcBtn.classList.add('is-loading');
      atcBtn.disabled = true;

      const variantId = document.getElementById('ag-variant-id-input')?.value;
      const quantity  = parseInt(qtyInput?.value || 1);

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ 
            id: parseInt(variantId), 
            quantity: quantity  // ← Explicitly pass the exact value
          })
        });

      if (!res.ok) throw new Error('Cart add failed');

      atcBtn.classList.remove('is-loading');
      atcBtn.classList.add('is-success');
      if (atcText) atcText.textContent = '✓ Added!';

      // Update cart count badge
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      document.querySelectorAll('#ag-header-cart-count, .ag-header__cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });

      // Fire event to open cart drawer (picked up by ag-header.js)
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      setTimeout(() => {
        atcBtn.classList.remove('is-success');
        atcBtn.disabled = false;
        if (atcText) atcText.textContent = 'Add to Bag';
      }, 2000);

    } catch (err) {
      atcBtn.classList.remove('is-loading');
      atcBtn.disabled = false;
      if (atcText) atcText.textContent = 'Try Again';
      setTimeout(() => { if (atcText) atcText.textContent = 'Add to Bag'; }, 2000);

      if (typeof window.agShowToast === 'function') {
        window.agShowToast('Could not add to cart. Please try again.', 'error');
      }
    } finally {
      // Release submission lock
      setTimeout(() => { isSubmitting = false; }, 500);
    }
  });

  /* ─── PDP Accordions (Scoped — no conflicts) ───────────────────── */

  document.querySelectorAll('.ag-accordion').forEach(accordion => {
    const trigger = accordion.querySelector('.ag-accordion__trigger');
    const body = accordion.querySelector('.ag-accordion__body');

    if (!trigger || !body) return;

    trigger.addEventListener('click', () => {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';

      trigger.setAttribute('aria-expanded', !isOpen);
      body.hidden = isOpen;
      body.classList.toggle('is-open', !isOpen);
    });
  });

})();
